(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.eventstop = factory());
}(this, (function () { 'use strict';

function eventstop() {
  var events = {};

  function select(event) {
    return events[event] || (events[event] = [])
  }

  function on(event, handler) {
    select(event).push(handler);
    return function () { return off(event, handler); }
  }

  function once(event, fn) {
    var handler = function () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      off(event, handler);
      fn.apply(void 0, args);
    };
    return on(event, handler)
  }

  function off(event, fn) {
    var sourceEvents = select(event);
    var index = sourceEvents.indexOf(fn);
    // why would I use `~index` if `!==` is more clear
    if (index !== -1) {
      sourceEvents.splice(index, 1);
    }
  }

  function emit(event) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

    for (var i = 0, list = select('*'); i < list.length; i += 1) {
      var handler = list[i];

      handler.apply(void 0, [ event ].concat( args ));
    }
    for (var i$1 = 0, list$1 = select(event); i$1 < list$1.length; i$1 += 1) {
      var handler$1 = list$1[i$1];

      handler$1.apply(void 0, args);
    }
  }

  return {
    on: on,
    off: off,
    once: once,
    emit: emit
  }
}

return eventstop;

})));



//////////////////
// WEBPACK FOOTER
// ./~/eventstop/dist/eventstop.js
// module id = 46
// module chunks = 0